import { Cycle, IntervalUnit } from '@wix/ambassador-premium-store/types';
import { CycleDetails, DoublePurchaseInfo, Product } from '../types';
import {
  DoublePurchaseValidationResult,
  DynamicDoublePurchaseValidationResult,
  PaymentCycle,
} from './consts';

export function calculateMonthlyPriceBefore(
  price: number,
  cycleMultiplier: number,
): number {
  return Math.ceil((price * 100) / cycleMultiplier) / 100;
}

export function currentProductCycle(
  product: Product,
  cycle: PaymentCycle,
): CycleDetails {
  return product.cycles.find((c) => c.cycleId === cycle) || product.cycles[0];
}

export function convertPaymentCycleToCycle(cycle: PaymentCycle): Cycle {
  let count, unit;
  switch (cycle) {
    case PaymentCycle.MONTHLY:
      count = 1;
      unit = IntervalUnit.MONTH;
      break;
    case PaymentCycle.QUARTERLY:
      count = 3;
      unit = IntervalUnit.MONTH;
      break;
    case PaymentCycle.YEARLY:
      count = 1;
      unit = IntervalUnit.YEAR;
      break;
    case PaymentCycle.YEAR3:
      count = 3;
      unit = IntervalUnit.YEAR;
      break;
    case PaymentCycle.YEAR4:
      count = 4;
      unit = IntervalUnit.YEAR;
      break;
    case PaymentCycle.YEAR5:
      count = 5;
      unit = IntervalUnit.YEAR;
      break;
    default:
      count = 2;
      unit = IntervalUnit.YEAR;
  }
  return { interval: { count, unit } };
}

export function convertCycleSelectorToPaymentCycle(
  alternativeCycle: Cycle,
): PaymentCycle {
  if (alternativeCycle.interval?.unit === IntervalUnit.MONTH) {
    if (alternativeCycle.interval?.count === 1) {
      return PaymentCycle.MONTHLY;
    }
    if (alternativeCycle.interval?.count === 3) {
      return PaymentCycle.QUARTERLY;
    }
  }
  if (alternativeCycle.interval?.unit === IntervalUnit.YEAR) {
    if (alternativeCycle.interval?.count === 1) {
      return PaymentCycle.YEARLY;
    }
    if (alternativeCycle.interval?.count === 2) {
      return PaymentCycle.YEAR2;
    }
    if (alternativeCycle.interval?.count === 3) {
      return PaymentCycle.YEAR3;
    }
  }

  throw new Error(
    `convertCycleSelectorToPaymentCycle: failed to convert input: ${JSON.stringify(
      alternativeCycle,
    )}`,
  );
}

export function convertDoublePurchaseStatusToCode(
  status: DynamicDoublePurchaseValidationResult,
): DoublePurchaseValidationResult {
  switch (status) {
    case DynamicDoublePurchaseValidationResult.SERVER_ERROR:
      return DoublePurchaseValidationResult.GENERAL_ERROR;
    case DynamicDoublePurchaseValidationResult.DELIVERED:
      return DoublePurchaseValidationResult.ALREADY_DELIVERED;
    default:
      return DoublePurchaseValidationResult.PENDING;
  }
}

export function getDoublePurchaseInfoDefaultValue(): DoublePurchaseInfo {
  return {
    info: {
      conflictingServiceGuid: '',
      planName: '',
      cycle: PaymentCycle.YEARLY,
    },
    validationCode: DoublePurchaseValidationResult.PENDING,
  };
}

export const stringifyDefinedQueryParams = (params: {
  [key: string]: string;
}): string => {
  const definedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== '',
    ),
  );
  const queryParams = new URLSearchParams(definedParams);
  return queryParams.toString();
};
